import type { BrandingLoadState } from '@/hooks/chat/useBranding'

export type StartupPhase =
  | 'authenticating'
  | 'loading_configuration'
  | 'loading_resources'
  | 'preparing_workspace'
  | 'ready'
  | 'error'

type StartupStateInput = {
  authStage: 'idle' | 'loading' | 'error'
  brandingLoadState: BrandingLoadState
  coreModuleLoadState: 'loading' | 'ready' | 'error'
  corePainted: boolean
  hasAccessToken: boolean
}

/** Project authoritative readiness signals into the user-visible startup phase. */
export function resolveStartupPhase({
  authStage,
  brandingLoadState,
  coreModuleLoadState,
  corePainted,
  hasAccessToken,
}: StartupStateInput): StartupPhase {
  if (authStage === 'error' || brandingLoadState === 'error' || coreModuleLoadState === 'error') {
    return 'error'
  }
  if (!hasAccessToken) {
    return 'authenticating'
  }
  if (brandingLoadState !== 'ready') {
    return 'loading_configuration'
  }
  if (coreModuleLoadState !== 'ready') {
    return 'loading_resources'
  }
  return corePainted ? 'ready' : 'preparing_workspace'
}
